<div class="page">
  <div class="dashboard-header">
    <div>
      <h4>{{ 'store.dashboard.greeting' | translate }}</h4>
      <div class="date">
        {{currentDate}}
      </div>
    </div>

    <div class="btns-container">
      <button (click)="scanRedeem()">
        <img src="assets/images/scan-btn.png" alt="">
        {{ 'store.dashboard.redeem' | translate }}
      </button>
      <button *ngIf="(featureFlagService.isFeatureEnabled$('store_vouchers') | async)" (click)="onCreateVoucher()">
        <img src="assets/images/add-btn.png" alt="">
        {{ 'store.dashboard.createVoucher' | translate }}
      </button>
    </div>

  </div>
  <div class="cards-main-container">
    <div class="card-container">
      <div class="card">
        <div class="title">{{ 'store.dashboard.cards.balance' | translate }}</div>
        <div  class="value"><span class="ltr-text">{{data?.balances[0]?.balance | currency:data?.balances[0]?.currency?.code : 'code'}}</span></div>
        <!--        <button disabled class="card-btn">-->
        <!--          Transfer Details-->
        <!--          <img src="assets/images/right-arrow.svg" alt="">-->
        <!--        </button>-->
      </div>
      <div class="card" *ngIf="(featureFlagService.isFeatureEnabled$('store_dashboard_vouchers') | async)">
        <div class="title">{{ 'store.dashboard.cards.vouchers' | translate }}</div>
        <div class="value">{{data?.vouchers}}</div>
      </div>
      <div class="card" *ngIf="(featureFlagService.isFeatureEnabled$('store_dashboard_available_codes') | async)">
        <div class="title">{{ 'store.dashboard.cards.availableCodes' | translate }}</div>
        <div class="value">{{data?.availableCodes}}</div>
      </div>
      <div class="card">
        <div class="title">{{ 'store.dashboard.cards.redemptionPoints' | translate }}</div>
        <div class="value">{{data?.redemptionPointsCount}}</div>
        <div class="card-footer">
          <button type="button" class="card-link" (click)="navigateToRedemptionPoints()">
            {{ 'store.dashboard.viewAll' | translate }}
            <img class="card-link__icon" src="assets/images/right-model.svg" alt="">
          </button>
        </div>
      </div>

    </div>
  </div>


</div>
<app-redeem-modal
  #redeemModal
  [currencyCode]="data?.balances[0]?.currency?.code || 'ILS'"
  (onRedeemAction)="onRedeem($event)"
  (onSuccess)="getData()">
</app-redeem-modal>
<ngx-spinner color="rgba(30, 205, 100, 1)" type="ball-scale-multiple"></ngx-spinner>
